import type { EnergyInputs, EnergyResult } from "./types";

export function calculateEnergy(inputs: EnergyInputs): EnergyResult {
  const energyFromImpulse = inputs.weldLength > 0 ? inputs.impulseEnergy / inputs.weldLength : 0;
  const energyFromPower = inputs.travelSpeed > 0 ? (inputs.power / inputs.travelSpeed) * 60 : 0;
  const difference = energyFromPower - energyFromImpulse;
  const differencePercent = energyFromImpulse > 0 ? (difference / energyFromImpulse) * 100 : 0;

  return {
    energyFromImpulse,
    energyFromPower,
    difference,
    differencePercent
  };
}
